export default __webpack_public_path__ + "static/media/8.be913639.jpg";